import React, { Component } from 'react'
import './ReadList.scss'
import { withCookies } from 'react-cookie'
import {RoleStr, getThumbnailSVG} from './Utils'

class ReadList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            readers: [],
        }
    }

    UNSAFE_componentWillMount() {
        const readers = this.props.readers.filter((item) => item.name !== '예비건축주')
        this.setState({ readers })
    }

    renderReader = () => {
        const List = this.state.readers
            .filter((item) => item.group !== '예비건축주')
            .map((item, i) => {
                let thumbnail = ''
                if (item.thumbnailUrl) {
                    thumbnail = <img src={item.thumbnailUrl} alt="profile" />
                } else {
                    thumbnail = getThumbnailSVG(item.group, 24)
                }

                return (
                    <div className="parent_wrap item_wrap">
                        <div className="content_wrap">
                            <div className="user">
                                <div className="thumbnail">{thumbnail}</div>
                                <p className="name">
                                    {RoleStr[item.group]} {item.name}
                                </p>
                            </div>
                        </div>
                    </div>
                )
            })

        return List
    }

    render() {
        return (
            <div className="read_wrap">
                <div className="comment_h1">
                    열람<span>{this.state.readers.length}</span>
                </div>
                <div className="list_wrap">{this.renderReader()}</div>
            </div>
        )
    }
}

export default withCookies(ReadList)



// WEBPACK FOOTER //
// ./Src/Components/Commons/ReadList.js